const certificateData = {
  "HUCYAL": ["Paresh gupta", "Vinay sharma", "Abhishek pareta", "Azan"],
  "L97A7J": ["Muskan Bano", "Anish Raj Yadav", "Dilansh Jain", "Mohd Riyaz"],
  "73PUMM": ["ROHIT MALI", "AKSHAT JAIN", "BHAVESH JAIN", "Samarth Choudhary"],
  "OLMH6G": ["Hitesh Jangir", "Jai Vishun Singh", "Kanhaiya Kumar", "Johit Kumar"],
  "I0VM0Q": ["Ankit Mehra", "Yogesh singh", "Pari Jain", "Paridhi Rao"],
  "5BKTAB": ["Satyam singhal", "Pratham khatri", "Sandesh das", "Sandeep kumar saini"],
  "TNI45Z": ["Lokesh kumar", "Laxman", "Krishna murti", "Kunal nogia"],
  "OLMBNR": ["Manvendra Rathore", "Md kaif", "Manish kumawat", "Mandeep saini"],
  "8QSZCQ": ["Anshul saini", "Riya sharma", "Tushar saini", "Mahfooz Hussian Sheikh"],
  "W5JOPC": ["Kumar Abhishek", "Manas Jain", "Prince Barnwal"],
  "Z43943": ["KUSH DHARMENDRA KATHURIA", "Jasaman Singh Chaggar", "Tanishq Garg", "Khushi Jaiswal"],
  "GDBPT1": ["Sachin sain", "Rohit verma", "Swati kumari", "Sneha kumari"],
  "6WLRHL": ["Nitesh Kumar", "Niraj Kumar", "Vedprakash", "Gunjan Sharma"],
  "4MMOVC": ["Pushkar Sharma", "Mohit", "Khushi Sharma", "Prachi Pandey"],
  "IPO17J": ["Peeyush ahluwaliya", "Ayush kumar sain", "Gajendra khilery", "Piyush Mer"],
  "3Z9W5R": ["Mayank jangir", "Sakshi Singh", "Mohammed Sami Khan", "Deepali"],
  "XNK5E0": ["Rahul Saini", "Ankit Mewara", "Lokesh Solanki", "Vishaka Sharma"],
  "T7SJF8": ["Praveen yadav", "Saksham Yadav", "Nirbhay gujjar", "Vineet faujdar"],
  "2TH3CM": ["Uday Kumar Das", "Shourya Tanwar", "Prem Soni", "Manjit Kumar Singh"],
  "Q88G2B": ["Vivek Bishnoi", "Pankaj", "Shalini", "Shrijal"],
  "B3ZJPZ": ["Sonam Kumari", "Vishnu Bhargav", "Vaibhav Soni", "Yashwant Kumar Koli"],
  "HVUES9": ["Hardik Pandita", "Vivek", "Yash Gupta", "Vikramaditya singh shekhawat"],
  "TYW02I": ["Tarun Prajapati", "Mohit Sharma", "Piyush Agarwal", "Sabhya Saini"],
  "KKD2DE": ["Vansh kalawatia", "Harshit sakhwaya", "Aditya sharma", "Yuvraj singh jadaun"],
  "T60MLF": ["Naveen singh", "Tarun soni", "Uday singh", "Vrashabh soni"],
  "VO20PI": ["Shreya Gupta", "Tejas", "Veer Prajapat Singh", "Sneha goyal"],
  "DH8KVL": ["Krish Kumar", "Arihant Jain", "Sharda Jangir", "Poorvangika Kanwar"],
  "1HN41W": ["Utkarsh upadhyay", "Yashika rohilla", "Rohit kumavat", "Kripa sharma"],
  "UZYH2D": ["Suman Goswami", "Utsav Singh", "Vishal Prajapati", "Rishabh Mishra"],
  "J9J5H0": ["Vivek mudgal", "Mohit lakhera", "Saksham kumawat ", "Shorya kumawat"],
  "OO4D4B": ["MOHAMMED TOUSEEF", "MADHAV AGRAWAL", "KANISHK KHICHAR", "MOHIT KUMAR PANDEY"],
  "0KNWO4": ["Sahil yadav", "Simran Thakur", "Aashish yadav", "Tanish Khan"],
  "45F49A": ["Yash soni", "Param Singh", "Punnet Bohra", "Neeraj Kumar"],
  "LUILBS": ["ANJALI SAINI", "Kiran Sharma", "Ankit jangir", "Amit Dixit"],
  "522PX8": ["Shubhanshu sain", "Vansh soni ", "Dheeraj Mamnani", "Aditya Raj Singh Shekhawat"],
  "SM00L6": ["Shivani Singh Chauhan", "Mehul Arora", "Kuldeep Soni", "Shriyanshu Singh"],
  "LBCOII": ["Nitin maan", "Lakshya chittoria ", "Mehul sharma", "Ruchi raj"],
  "60G7UL": ["RAJ MAYUK KUMAR", "SHIVANI MANDORA", "SUBRATO DUTTA", "ANJALI PAL"],
  "6RN012": ["Khushwant Singh Rajpurohit", "Himanshu", "Nitin Sisodiya", "Jyotiraditya"],
  "JEUMRF": ["Dishant Panchal", "Gaurav Jain", "Vishesh Panchal", "Aadarsh Kalal"],
  "AXKPLW": ["Arvind Jhajhara", "Aryan banarjee", "Amit khatri", "Gaurav chahar"],
  "WYJHG0": ["Ali Akbar Khan", "Mohammad Sohail Ali", "Dhruv Mishra", "Yash Mishra"],
  "GGYL8B": ["Kuldeep Jagarwal", "Mann Saxena", "Aashish pal", "Parmod Kumar"],
  "0PXTUM": ["Sachin kumar jatavat", "Krishna", "Priyanshi jaishwal", "Vatsal"],
  "TLK813": ["Nikhil Bhargav", "Vishwaranjana kumar singh", "Dhairya kumawat", "Mohammad Sadiq"],
  "NUTQ6K": ["Mohammad Asad", "MOHAMMAD NOMAN", "Hitesh sharma", "Kalpesh sharma"],
  "WWW4Z2": ["Daksh Tanwar", "Vivek", "Prakhar", "Priyanka Jain"],
  "C08VJ3": ["Deepak kumar", "Chanda kumari", "Dheeraj Rathore", "Chetan kumar"],
  "WB61BF": ["Vishnu Singh", "Yashpal Bhati", "Vishnu kumar Saini", "Shubham Singh"],
  "5KLXFX": ["Nirbhay gurjar", "Praveen Kumar bunker", "Vishnu bunker", "Nikhil singh"],
  "EM9B5T": ["Pritam Jangid", "Deepesh", "Shivanshu Kumar Srivastava", "Rishi Raj Ambasta"],
  "NZOGF3": ["Pransi Gupta", "Shivam Trivedi", "Harsh gupta", "Rishi raj saini"],
  "K08N9R": ["Goutam Baid", "Ritviz Tiwari", "Hitesh Gourana", "Aaryan Arora"],
  "D2Z3QX": ["Mohit kumar", "Aman Ojha", "Tanmay Chhipa"],
  "Q8RGU5": ["Vishal Bhargav", "Vinit Saini", "Vinay Soni", "Priyanka Varindani"],
  "PDHO10": ["Raghav Tailor", "Adarsh", "Anshi Rathore", "Dakshita biwal"],
  "I9AUOD": ["Tarun", "Ghanshyam Jangid", "Tarun Kumar"],
  "53DCHQ": ["Yash Kumar", "Hariom patidar", "Babulal sidh", "Vikash Yadav"],
  "TE3J5A": ["Pawan Singh Sodha", "Aditya yadav", " Prashant singh bidawat"],
  "0OGHD5": ["Srashti kulshrestha", "Arti Soni", "Gargi Mathuriya", "Tanuj Sharma"],
  "HS5DBU": ["Vishal Singh", "Vishal Jangid", "Manjeet Dhanka"],
  "KPA4AR": ["Sahil Singh", "Naveen Singh Chundawat", "Narendra kumawat"],
  "HONO3Y": ["Shivangi Padyar", "Priyanshi Sharma", "Jatin Gupta", "Anshul Yadav"],
  "5GSWCS": ["Ankit kumar", "Nupur sharma", "Navya Agarwal", "Anshika panday"],
  "9HYKDO": ["Kartikey Sharma", "Hemlata", "Mehul Bhargav"],
  "MJ3S4H": ["Abhishek Singh", "Dhruv Vaishnav", "Arayan Shah", "Khushi Vyas"],
  "D3DUQM": ["ANKIT", "JAINAM MEHTA", "HARSHVARDHAN CHAUAN", "HIMANSHU SONI"],
  "UDN5SJ": ["Bharat Saini", "Tanveer Singh", "Dhruv Saini", "Veer Singh"],
  "A3W925": ["Arjun Singh_The Logistics Legends", "Aniket Sharma", "Disha Lakhwani", "Anshika Sharma"],
  "ZVC024": ["Shivraj Singh", "Santanu Dubey", "Shivam Morya", "Shivratan"],
  "WBY7TQ": ["Vikas Kumar Dabi", "Vikas Kumawat", "Babita Shekhawat", "Shyalu Kumawat"],
  "QQ3YPD": ["Anamika Shah", "Ankush Poonia", "Dharmraj Verma", "Himanshi Chouhan"],
  "J4EDMJ": ["Ansh Sharma", "Ankit saini", "Ganesh kumawat", "Adarsh Sharma"],
  "YB7K0U": ["Aditya naagar", "Aayushman brahmbhatt", "Khushal"],
  "63P67T": ["Rajvardhan Sharma", "Tushar Motwani", "Rajveer Singh Rathore", "Prasoon Mishra"],
  "Q3J6MQ": ["Adnaan khan", "Ahtesham", "Yashpal", "Prince Vinayak Rohilla"],
  "Z7QW2X": ["Roshan Sharma", "Nitya Patel", "Vikas Yadav"],
  "DHQ6F0": ["Aayush Sharma", "Akash kumar", "Deependra"],
};

export default certificateData;
